interface EditIconProps {
  className?: string;
  onClick?: () => void;
 
}

const EditIcon = (props: EditIconProps) => {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${props.className ? props.className : ""} cursor-pointer`}
      >
        <path
          d="M22.8721 13.5669L22.8721 15.5669C22.8721 20.5669 20.8721 22.5669 15.8721 22.5669L9.87207 22.5669C4.87207 22.5669 2.87207 20.5669 2.87207 15.5669L2.87207 9.56689C2.87207 4.56689 4.87207 2.56689 9.87207 2.56689L11.8721 2.56689"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.8518 8.52701L13.9718 16.407C13.6718 16.707 13.0818 17.007 12.6518 17.067L9.64182 17.497C8.55182 17.657 7.79182 16.887 7.94182 15.797L8.37182 12.787C8.43182 12.367 8.73182 11.777 9.03182 11.467L16.9118 3.58702C18.2718 2.22702 19.8518 1.58702 21.8518 3.58702C23.8518 5.58702 23.2118 7.16701 21.8518 8.52701Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7217 9.65674C18.3317 8.98674 16.4617 7.11674 15.7817 4.71674"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default EditIcon;
